import React from 'react';
import "./RewardResponsive.scss";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";

function RewardResponsive({
                              history,
                              InvCard,
                              InvCard_skeleton,
                              showRewardM,
                              load,
                              user,
                              RewardHistoryCard,
                              rewardsHistory,
                              selectedReport,
                              RewardCard,
                              invo,
                              getFactorDetail,
                              creditCard,
                              globalActiveTab,
                              set_activeTab,
                              activeTab,
                              rewards
}){
    return(
        <div>
            
            
            <DrShopHeader home={true}/>

            <div className="reward-responsive-container">
                <div className="reward-body">
                    {/*Credit Card*/}
                    {/*<div className="creditCard" style={{backgroundColor:"rgb(207 207 207)"}}>*/}
                    <div className="creditCard" style={{backgroundImage: `url(${creditCard.image})`}}>

                        <div className="card-title-sec" >
                            <span style={{color:`#${creditCard.title_color?creditCard.title_color:"#ffffff"}`}}>{creditCard.title}</span>
                        </div>

                        {/*<div className="card-log-sec">*/}
                        {/*    <img src={creditCard.image}  style={{width:100,height:100,padding:24}} alt="" />*/}
                        {/*</div>*/}

                        {/*<div className="rewardCard-logo">*/}
                        {/*    /!*<img src="/other/reward/reward_logo.svg" alt=""/>*!/*/}
                        {/*    <img src={creditCard.image} alt="" />*/}
                        {/*</div>*/}

                        {/*<div className="rewardCard_name" style={{color:`#${creditCard.title_color?creditCard.title_color:"#ffffff"}`}}>*/}
                        {/*    <span>{creditCard.title}</span>*/}
                        {/*</div>*/}

                        <div className="rewardCard-info" onClick={()=>{
                            history.push("/profile")
                        }}>
                            {/*<span>{creditCard.uid?creditCard.uid:"---"}</span>*/}
                            <span style={{color:`#${creditCard.name_color?creditCard.name_color:"#ffffff"}`}}>{user && user.first_name ? user.first_name+" "+user.last_name:"نام خود را وارد نمایید"  }</span>
                        </div>

                        <div className="rewardCard-credit">
                            <span style={{color:`#${creditCard.point_color?creditCard.point_color:"#ffffff"}`}}>موجودی : {creditCard.uid?creditCard.card_points:"-"} امتیاز</span>
                        </div>

                    </div>


                    {/*{festivalsStatus?<div className="reward-banner" onClick={e=>{*/}
                    {/*    history.push("/festivals")*/}
                    {/*}}>*/}
                    {/*    <img src="https://s3.mobank.co/loyalty-media/page/section_item/images/Group_3548_SYwCIa7.png" alt=""/>*/}
                    {/*</div>:null}*/}


                    {/*Options list*/}
                    <div className="options-list">
                        <div className="options-item reward-question-btn" onClick={()=>history.push("/festivals",{credit:creditCard})}>
                            {/*<img src="/other/reward/reward_q.svg" alt=""/>*/}
                            <img src="/other/sample1.gif" alt=""/>
                            <span>جشنواره ها</span>
                        </div>
                        <div className="options-item reward-gift-btn"
                             onClick={()=>history.push("/awards")}
                        >
                            {/*<img src="/other/reward/reward_gift.svg" alt=""/>*/}
                            <img src="/other/sample2.gif" alt=""/>
                            <span>جایزه ها</span>
                        </div>
                    </div>



                    {/*new tabs*/}
                    <div className="new-tabs">
                        <div  className={activeTab==="order"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}

                              onClick={()=>{
                                  window.currentPage = 1;
                                  set_activeTab("order")
                                  globalActiveTab = "order"

                              }} >
                            {activeTab==="order"?<img src="/other/order_tab_selected.png" alt=""/>:<img src="/other/order_tab_default.jpg" alt=""/>}
                            <span>سفارش ها</span>
                        </div>
                        <div className={activeTab==="reward_history"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}

                             onClick={()=>{
                                 window.currentPage = 1;
                                 set_activeTab("reward_history")
                                 globalActiveTab = "reward_history"
                             }} >
                            {activeTab==="reward_history"?<img src="/other/history_tab_selected.png" alt=""/>:<img src="/other/history_tab_default.png" alt=""/>}
                            <span>تاریخچه امتیازها</span>
                        </div>
                        <div
                            className={activeTab==="reward"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}
                            onClick={()=>{
                                window.currentPage = 1;
                                set_activeTab("reward")
                                globalActiveTab = "reward"
                            }}>
                            {activeTab==="reward"?<img src="/other/reward_tab_selected.png" alt=""/>:<img src="/other/reward_tab_default.png" alt=""/>}
                            <span>تخفیف ها</span>
                        </div>
                    </div>


                    {/*rewards & order tabs */}
                    <div className="tabs">


                        {activeTab==="reward"?
                            <div className="rewards-tab">
                                <div className="rewards-tab-list">
                                    {rewards.map(i=>{
                                        return(
                                            <RewardCard showModal={showRewardM} item={i}/>
                                        )
                                    })}
                                </div>
                            </div>:null}

                        {activeTab==="reward_history"?
                            <div className="rewards-tab">
                                <div className="rewards-tab-list">
                                    {rewardsHistory.map(i=>{
                                        return(
                                            <RewardHistoryCard showModal={showRewardM} item={i}/>
                                        )
                                    })}
                                </div>
                            </div>:null}

                        {activeTab==="order"?
                            <div className="orders-tab">
                                <div className="orders-tab-list">
                                    {selectedReport === "cat" ? <div className="cat-list">
                                        {invo.length < 1 ?
                                            <>
                                                <InvCard_skeleton show={load}/>
                                            </>
                                            : null}
                                        {invo.map(item => {
                                            return (
                                                <InvCard item={item} getFactorDetail={getFactorDetail}/>
                                            )
                                        })}
                                    </div> : null}
                                </div>
                            </div>:null
                        }


                    </div>
                </div>
            </div>


            <FooterDesktop/>
        </div>
    )
}

export default RewardResponsive
